export default (detail) => {
  const ev = new window.CustomEvent('add_edit_modal:open', { detail })
  window.dispatchEvent(ev)
}
